import React from 'react';
import { guc } from '../../Localisation';
import { isEmptyString } from '../../../utils';

const useTawk = () => {
    
    const tawkID = guc('tawk_id');
    
    React.useEffect(() => {
        if (!guc('oyo_chat_enabled') && !isEmptyString(tawkID)) {
            const Tawk_API = Tawk_API || {};
            const Tawk_LoadStart = new Date();
            const s1 = document.createElement('script');
            s1.type = 'text/javascript';
            s1.async = true;
            s1.src = 'https://embed.tawk.to/6107bcf2649e0a0a5ccf1278/' + tawkID;
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            const s0 = document.getElementsByTagName('script')[0];
            s0.parentNode.insertBefore(s1, s0);
        }
    });
};

export default useTawk;
